export const GET_COMMENTS_REQUEST = "GET_COMMENTS_REQUEST";
export const GET_COMMENTS_RECEIVE = "GET_COMMENTS_RECEIVE";
export const GET_COMMENTS_FAILURE = "GET_COMMENTS_FAILURE";
export const RESET_GET_COMMENTS = "RESET_GET_COMMENTS";

export const CREATE_COMMENT_REQUEST = "CREATE_COMMENT_REQUEST";
export const CREATE_COMMENT_RECEIVE = "CREATE_COMMENT_RECEIVE";
export const CREATE_COMMENT_FAILURE = "CREATE_COMMENT_FAILURE";
export const RESET_CREATE_COMMENT = "RESET_CREATE_COMMENT";

export const UPDATE_COMMENT_REQUEST = "UPDATE_COMMENT_REQUEST";
export const UPDATE_COMMENT_RECEIVE = "UPDATE_COMMENT_RECEIVE";
export const UPDATE_COMMENT_FAILURE = "UPDATE_COMMENT_FAILURE";
export const RESET_UPDATE_COMMENT = "RESET_UPDATE_COMMENT";

export const DELETE_COMMENT_REQUEST = "DELETE_COMMENT_REQUEST";
export const DELETE_COMMENT_RECEIVE = "DELETE_COMMENT_RECEIVE";
export const DELETE_COMMENT_FAILURE = "DELETE_COMMENT_FAILURE";
export const RESET_DELETE_COMMENT = "RESET_DELETE_COMMENT";